module.exports = __webpack_public_path__ + "assets/zhuyishixiang.5845ae01.svg";